import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  applyBatteryConcertApplicationStatus,
  invalidateBatteryConcertApplication,
} from "./battery-concert-application-cache"
import type { BatteryConcertApplicationStatusDto } from "../dto/battery-concert-application.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Generate the Concert loan documents for an approved Battery application. The
 * server holds the claim, so a retry after a failure cannot ask Concert to
 * build a second package while the first is still in flight.
 */
export default function useGenerateBatteryConcertLoanDocuments(): UseMutationResult<
  BatteryConcertApplicationStatusDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }) =>
      batteryProposalService.generateConcertLoanDocuments(proposalId),
    onSuccess: (status, { proposalId }) => {
      applyBatteryConcertApplicationStatus(queryClient, proposalId, status)
    },
    onError: (_error, { proposalId }) => {
      invalidateBatteryConcertApplication(queryClient, proposalId)
    },
  })
}
